import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ExternalLinkService } from '../../services/external-link/external-link.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
    public year: number;
    termsLink: string;
    privacyLink: string;
    ccpaLink: string;
    private langSubscription!: Subscription;

    constructor(private linkService: ExternalLinkService, private translate: TranslateService) {
        this.year = new Date().getFullYear();
        this.termsLink = this.linkService.getLink('TERMS_OF_USE');
        this.privacyLink = this.linkService.getLink('PRIVACY_POLICY');
        this.ccpaLink = this.linkService.getLink('CALIFORNIA_POLICY');
    }

    ngOnInit(): void {
        this.langSubscription = this.translate.onLangChange.subscribe(() => {
            this.termsLink = this.linkService.getLink('TERMS_OF_USE');
            this.privacyLink = this.linkService.getLink('PRIVACY_POLICY');
            this.ccpaLink = this.linkService.getLink('CALIFORNIA_POLICY');
        });
    }

    ngOnDestroy(): void {
        if (this.langSubscription) {
            this.langSubscription.unsubscribe();
        }
    }
}
